import { graphql } from "~/gql";

export const BEDROCK_GET_PHASES_AND_TASKS_QUERY = graphql(/* GraphQL */ `
  query BedrockGetPhasesAndTasks(
    $matterId: Float!
    $useLibraryData: Boolean!
    $refineMode: Boolean
    $customPrompt: String
    $countryCode: String
  ) {
    bedrockGetPhasesAndTasks(
      matterId: $matterId
      useLibraryData: $useLibraryData
      refineMode: $refineMode
      customPrompt: $customPrompt
      countryCode: $countryCode
    ) {
      phaseTitle
      tasks
    }
  }
`);
